<template>
	<div class='lmAes-falcon'>
    <h2>RAG 应用引擎 Falcon 的特点</h2>
    <div class="box">
      <img src="../../assets/images/lmaesFalcon.png"/>
      </div>
	</div>
</template>

<script>
	export default {
		name: 'LmAesFalcon'
	}
</script>

<style scoped>
    .lmAes-falcon {
      background: #ffffff;
      padding: 4.16vw 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .lmAes-falcon h2 { 
      max-width: 80vw;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #3963B3;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .lmAes-falcon .box {
      width: 100%;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lmAes-falcon .box img {
      width: 58.75vw;
      height: 32.71vw;
    }
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/LmAesFalcon.vue